import React from 'react';
import HotelAssessmentSelection from '../Header/HotelAssessmentSelection';
import union from '../../../../www/assets/svg/union.svg';
import { AppHeader } from '../../../app/common/sharedComponents/AppHeader';

interface IPendingAssessment {
  assessments: {stayStart: string; id: number; score?: number}[];
  setAssessments: (i) => void;
  selectedHotel: string;
  setSelectedHotel: (i) => void;
  selectedClient: string;
  setSelectedClient: (i) => void;
  selectedAssessment?: string;
  setSelectedAssessment: (i) => void;
  isSelectDate?: boolean;
  isLoading?: boolean; 
  setIsLoading: any;
  lqaCompset?: any;
  selectedCompset: number;
  setSelectedCompset: (i) => void;
  hasAssessment?: boolean;
  setHasAssessment: (i) => void;
}

const PendingAssessment = (props: IPendingAssessment) => {
  const {
    selectedHotel,
    setAssessments,
    setSelectedHotel,
    selectedClient,
    setSelectedClient,
    selectedAssessment,
    setSelectedAssessment,
    assessments,
    isLoading,
    setIsLoading,
    lqaCompset,
    selectedCompset,
    setSelectedCompset,
    hasAssessment,
    setHasAssessment,
  } = props;
  return(
        <>
          <div className="header">
            <AppHeader hasBackButton={false} />
            <HotelAssessmentSelection
              assessments={assessments}
              setAssessments={setAssessments}
              selectedHotel={selectedHotel}
              setSelectedHotel={setSelectedHotel}
              selectedClient={selectedClient}
              setSelectedClient={setSelectedClient}
              selectedAssessment={selectedAssessment}
              setSelectedAssessment={setSelectedAssessment}
              isSelectDate={true}
              isLoading={isLoading} 
              setIsLoading={setIsLoading}
              lqaCompset={lqaCompset}
              selectedCompset={selectedCompset}
              setSelectedCompset={setSelectedCompset}
              hasAssessment={hasAssessment}
              setHasAssessment={setHasAssessment}
            />
          </div>
            <div className="p-20 text-center mt-250">
              <img src={union} className="mb-50 p-60" />
              <div className="text-center">
                <p className="fw-600 f-20 lh-24 color-1F1F1F mb-20">Pending Hotel Assessment</p>
                <p className="fw-600 f-20 lh-24 color-1F1F1F mb-20">
                  Your hotel has not been assessed yet. Please return for valuable insights once your audit is complete
                </p>
                <p className="fw-600 f-20 lh-24 color-1F1F1F">Thank you.</p>
              </div>
            </div>        
        </>
    );
};

export default PendingAssessment;
